import { render, staticRenderFns } from "./IdentificationWorld.html?vue&type=template&id=6f568de4&scoped=true&"
import script from "./IdentificationWorld.ts?vue&type=script&lang=ts&"
export * from "./IdentificationWorld.ts?vue&type=script&lang=ts&"
import style0 from "./IdentificationWorld.scss?vue&type=style&index=0&id=6f568de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f568de4",
  null
  
)

export default component.exports